import type { FaireProductEntity } from "../../entity_types/product";

export const p_gwjrmjhzsg: FaireProductEntity = {
  token: "p_gwjrmjhzsg",
  type: "product",
  name: "Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e6508eb2f45cbf3e10d9d00cd75342d91f46d0411ea4130802f76f2faba4b28c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11c64a0c2f9814ccdf3a9c58629f655224a082ec56a3cc5deea6ae92c11cc54c.jpeg",
    "https://cdn.faire.com/fastly/9572afaed0b37ae75015d4fa1cd1631089a541a3e4b2521bb3ac7cb0e1e92fcd.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/5bda90760c3f693e9b2651cd4bfd933569c487ec256e107bf716af0855ed756e.jpeg",
    "https://cdn.faire.com/fastly/bf70685da7e686f6aaac0dd23244bdae4d8a89191220a5eed1ec9d6ada4f301b.jpeg"
  ],
  priceDollars: 6.75,
  description: "You know better because you are better. You deserve the socks to match.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:32.140Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
